export default __webpack_public_path__ + "static/media/caption-3-min.7f9c3607.jpg";